module.exports = __webpack_public_path__ + "img/acolman.8e4461d5.jpg";